import {FC} from 'react';
import {useGetCompaniesCidPersonsQuery} from '../../../../global/services/companies';
import {styled, Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material';
import {compact, get, join, map} from 'lodash';

interface Props {
  companyId: string;
}

export const ContractCompanyPersons: FC<Props> = ({companyId}) => {
  const {data} = useGetCompaniesCidPersonsQuery(companyId);

  if (!data?.length) return null;

  return (
    <Table>
      <TableHead>
        <TableRow>
          <StyledTableHeadCell align="center">Контактное лицо</StyledTableHeadCell>
          <StyledTableHeadCell align="center">Должность</StyledTableHeadCell>
          <StyledTableHeadCell align="center">Контактная информация</StyledTableHeadCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((person) => (
          <TableRow key={person.id}>
            <TableCell align="center">
              {join(compact([get(person, 'lastName'), get(person, 'firstName'), get(person, 'patronymic')]), ' ')}
            </TableCell>
            <TableCell align="center">{join(map(person.relations, 'relationTitle'), ', ')}</TableCell>
            <TableCell align="center">{person.phoneNumber}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const StyledTableHeadCell = styled(TableCell)({
  fontWeight: 'bold',
});
